import { ChangeDetectorRef, Directive, ElementRef, ViewChild } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { FinraRouterOutletAnchorDirective } from '../../dynamic-component/directive/finra-router-outlet-anchor.directive';
import { AppHost } from '../service/appHost.service';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export class MicroApp {
  private _routes: {
    [routePath: string]: {
      component: any;
    };
  };
  public get routes(): {
    [routePath: string]: {
      component: any;
    };
  } {
    return this._routes;
  }
  public set routes(value: {
    [routePath: string]: {
      component: any;
    };
  }) {
    this._routes = value;
  }

  @ViewChild(FinraRouterOutletAnchorDirective, { static: true }) anchor: FinraRouterOutletAnchorDirective;

  constructor(
    protected appHost: AppHost,
    public changeDetectorRef: ChangeDetectorRef,
    public elementRef: ElementRef,
  ) {
    setTimeout(() => {
      this.appHost.activeMicroApp = this;

      // using the native event dispatcher instead of angular
      // angular has random aot issues with CustomEvents
      const event = new CustomEvent('finraMicroAppLoaded', { detail: { service: this.appHost } });
      this.elementRef.nativeElement?.dispatchEvent?.(event);
    });

    appHost.initialized
      .pipe(
        filter((ready) => !!ready),
        take(1),
      )
      .subscribe(() => {
        this.onMicroAppInit();
        this.changeDetectorRef.markForCheck();
      });

    // expose shouldWarnBeforeExit() directly on the web component instance
    (this.elementRef.nativeElement as any).shouldWarnBeforeExit = this.shouldWarnBeforeExit.bind(this);
  }

  protected onMicroAppInit() {}

  public shouldWarnBeforeExit(): boolean {
    return false;
  }
}
